function megaMenu() {
  /*
  / Mobile Off Canvas Menu
  */

  $('[data-trigger]').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    var offcanvas_id = $(this).attr('data-trigger');
    $(offcanvas_id).toggleClass('show');
    $('body').toggleClass('offcanvas-active');
  });

  $('.navbar-toggler').click(function () {
    // Close Search overlay if open
    $("#search-overlay-trigger.active").each(function() {
      $(this).trigger("click");
    })


    $(this).toggleClass('close');
  });


  // a single MediaQuery
  const isMobile = window.matchMedia('only screen and (max-width: 1200px)');

  // -- Mobile Submenu Open
  $('#mega-menu-wrap .mega-menu-link.has-dropdown .chevron').click(function (e) {
    if (!isMobile.matches) return; // if mobile view, then do nothing
    //console.log('submenu open');
		$(this).parents('.mega-menu-link.has-dropdown').siblings('.mega-menu-dropdown').addClass('active');

		e.preventDefault();
  });

  // -- Mobile Submenu Close
  $('#mega-menu-wrap .mega-menu-dropdown .mega-menu-back').click(function (e) {
    if (!isMobile.matches) return; // if mobile view, then do nothing
    //console.log('submenu close');
		$(this).parents('.mega-menu-dropdown').removeClass('active');
		e.preventDefault();
	});

  // -- Mobile Close menu on second level remove active so it resets to top level
  $('#mega-menu-wrap .mega-menu-dropdown .close').click(function (e) {
    if (!isMobile.matches) return; // if mobile view, then do nothing
		$(this).parents('.mega-menu-dropdown').removeClass('active');
		e.preventDefault();
	});
}

$(document).ready(function(){
  megaMenu();
});
